import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AmlCheckRequest } from '@/api';
import { ErrorCodeEnum } from '@/config';

export interface AmlCheckSliceState {
  loading: boolean;
  error: string | null;
  errorCode: ErrorCodeEnum | null;
}

const initialState: AmlCheckSliceState = {
  loading: false,
  error: null,
  errorCode: null,
};

const amlCheckSlice = createSlice({
  name: 'amlCheck',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
    setError: (state, action: PayloadAction<string | null>) => ({
      ...state,
      error: action.payload,
    }),
    setErrorCode: (state, action: PayloadAction<ErrorCodeEnum | null>) => ({
      ...state,
      errorCode: action.payload,
    }),
    checkAml: (state, action: PayloadAction<AmlCheckRequest>) => ({
      ...state,
      error: null,
      loading: true,
      errorCode: null,
    }),
    investigate: (state, action: PayloadAction<AmlCheckRequest>) => ({
      ...state,
      error: null,
      loading: true,
      errorCode: null,
    }),
    checkAgain: (state, action: PayloadAction<string>) => ({
      ...state,
      error: null,
      loading: true,
      errorCode: null,
    }),
  },
});

export { amlCheckSlice };
